export default __webpack_public_path__ + "static/media/category-icon.095f1de9.svg";